export function useForm(id: MaybeRefOrGetter<string>) {
  const { $directus, $readItem } = useNuxtApp()

  const formId = toValue(id)
  return useAsyncData(`form-${formId}`, async () => {
    return await $directus.request($readItem('forms', formId, {
      fields: [
        'id',
        'name',
        {
          translations: ['*'],
          submit_translations: ['*'],
          form_inputs: [
            'collection',
            'id',
            {
              item: {
                form_divider: ['*', {
                  translations: ['*'],
                }],
                form_text_input: ['*', {
                  translations: ['*'],
                }],
                form_email_input: ['*', {
                  translations: ['*'],
                }],
                form_textarea_input: ['*', {
                  translations: ['*'],
                }],
                form_single_checkbox_input: ['*', {
                  translations: ['*'],
                }],
                form_address_input: ['*', {
                  translations: ['*'],
                }],
                form_checkbox_group_input: ['*', {
                  translations: ['*'],
                  options: [{
                    form_checkbox_group_input_item_id: ['*', {
                      translations: ['*'],
                    }],
                  }],
                }],
                form_submit_button: ['*', {
                  translations: ['*'],
                }],
                form_special_dealer_selector: ['*', {

                }],
                form_special_checkbox_choice: ['*', {
                  translations: ['*'],
                  options: [{
                    form_special_checkbox_choice_item_id: ['*', {
                      translations: ['*'],
                    }],
                  }],
                }],
              },
            },
          ],
        },
      ],
    })) as FormStructureResponse
  })
}

interface FormStructureResponse {
  id: string
  name: string
  form_inputs: FormInput[]
  submit_translations: DirectusTranslation<{
    text: string
  }>
}

type FormInput
  = | {
    collection: 'form_divider'
    id: number
    item: FormDividerInput
  }
  | {
    collection: 'form_text_input'
    id: number
    item: FormTextInput
  }
  | {
    collection: 'form_email_input'
    id: number
    item: FormEmailInput
  }
  | {
    collection: 'form_textarea_input'
    id: number
    item: FormTextareaInput
  }
  | {
    collection: 'form_single_checkbox_input'
    id: number
    item: FormSingleCheckboxInput
  }
  | {
    collection: 'form_address_input'
    id: number
    item: FormAddressInput
  }
  | {
    collection: 'form_checkbox_group_input'
    id: number
    item: FormCheckboxGroupInput
  }
  | {
    collection: 'form_special_dealer_selector'
    id: number
    item: FormSpecialDealerSelector
  }
  | {
    collection: 'form_special_checkbox_choice'
    id: number
    item: FormSpecialCheckboxChoice
  }

export interface FormDividerInput {
  id: number
  translations: DirectusTranslation<{
    text: string
  }>
}

export interface FormTextInput {
  id: number
  key: string
  required: boolean
  width: InputWidth
  translations: DirectusTranslation<{
    label: string
    placeholder: string
  }>
}

export interface FormEmailInput {
  id: number
  key: string
  required: boolean
  width: InputWidth
  translations: DirectusTranslation<{
    label: string
    placeholder: string
  }>
}

export interface FormTextareaInput {
  id: number
  key: string
  required: boolean
  translations: DirectusTranslation<{
    label: string
    placeholder: string
  }>
}

export interface FormSingleCheckboxInput {
  id: number
  key: string
  required: boolean
  translations: DirectusTranslation<{
    label: string
  }>
}

export interface FormAddressInput {
  id: number
  key: string
  required: boolean
  translations: DirectusTranslation<{
    label: string
    placeholder: string
  }>
}

export interface FormCheckboxGroupInput {
  id: number
  key: string
  required: boolean
  translations: DirectusTranslation<{
    label: string
  }>
  options: {
    form_checkbox_group_input_item_id: FormCheckboxGroupInputOption
  }[]
}

export interface FormCheckboxGroupInputOption {
  id: number
  value: string
  key: string
  translations: DirectusTranslation<{
    text: string
  }>
}

export interface FormSpecialDealerSelector {
  id: number
  key: string
}

export interface FormSpecialCheckboxChoice {
  id: number
  key: string
  required: boolean
  translations: DirectusTranslation<{
    divider_text: string
    label: string
  }>
  options: {
    form_special_checkbox_choice_item_id: FormSpecialCheckboxChoiceOption
  }[]
}

export interface FormSpecialCheckboxChoiceOption {
  id: number
  value: string
  key: string
  translations: DirectusTranslation<{
    title: string
    description: string
  }>
}

export interface FormSubmitButton {
  id: number
  translations: DirectusTranslation<{
    text: string
  }>
}

type InputWidth = 'full' | 'half'
